export const CatalogTransferWizardStep = {
    SelectTransferType: 0,
    SourcePublisher: 1,
    VerifyWorks: 2,
    ExportCatalog: 3,
    ImportCatalog: 4,
    TargetPublisher: 5,
    UploadDocumentation: 6,
    ExtraInfo: 7,
    Review: 8,
} as const
